'use client';

let IMAGE_OPTIMIZATION_API_FROM_CORE = null;

try {
  // Try to require the module if it exists.
  const coreImageOptimizationApi = require('@eliadmin/core/next-images-optimization-api-url');
  IMAGE_OPTIMIZATION_API_FROM_CORE = coreImageOptimizationApi.IMAGE_OPTIMIZATION_API_FROM_CORE;
} catch (error) {
  console.error('Module @eliadmin/core/next-images-optimization-api-url not found:', error);
  IMAGE_OPTIMIZATION_API_FROM_CORE = null; // Fallback in case the module is not available.
}

export default function myImageLoader({ src, width, quality }) {
  const isLocal = !src.startsWith('http');
  const query = new URLSearchParams();

  const imageOptimizationApi =
    process.env.IMAGE_OPTIMIZATION_API ??
    IMAGE_OPTIMIZATION_API_FROM_CORE ??
    'https://eliadmin.b-cdn.net/image';

  const baseUrl = process.env.NEXT_PUBLIC_APP_URL;

  const fullSrc = `${baseUrl}${src}`;

  if (width) query.set('width', width);
  query.set('quality', quality || 75);

  if (isLocal && process.env.NODE_ENV === 'development') {
    return src;
  }

  // Source URLs can already contain ?ai=0. A second '?' makes the CDN
  // interpret width as part of ai instead of resizing the image.
  const url = `${imageOptimizationApi}/${isLocal ? fullSrc : src}`;
  const [pathname, hash] = url.split('#', 2);
  return `${pathname}${pathname.includes('?') ? '&' : '?'}${query.toString()}${hash ? `#${hash}` : ''}`;
}
